<template>
    <div class="news-card" v-if="cardArr != null">
        <div class="container">
            <div class="page-title">
                <h1 v-if="globalLang == ''">Новости</h1>
                <h1 v-if="globalLang == 'kz/'">Жаңалықтар</h1>
                <router-link to="/news" class="back-to-news">
                    <svgIcon name="arrow-back" class="icon-arrow-back"/>
                    <span v-if="globalLang == ''">Назад ко всем новостям</span>
                    <span v-else>Барлық жаңалықтарға оралу</span>
                </router-link>
            </div>
            <div class="card-columns">
                <div class="col-left">
                    <div class="card-title">
                        <strong class="news-date">{{correctDate(cardArrDate)}}</strong>
                        <h2>{{parseTitle(cardArr.title)}}</h2>
                        <div class="link-item-share">
                            <div class="social-links-container">
                                <div class="soc-link-in">
                                    <SWhatsApp
                                        :share-options="{
                                            text: parseTitle(cardArr.title) + ','  + 'https://test.dialgroup.kz/news/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="wapp" class="icon-soc icon-wapp"/></SWhatsApp>
                                    <STelegram
                                        :share-options="{
                                            text: parseTitle(cardArr.title),
                                            url: 'https://test.dialgroup.kz/news/' + cardID
                                        }"
                                        :use-native-behavior="true"
                                    ><svgIcon name="telapp" class="icon-soc icon-telapp"/></STelegram>
                                </div>
                            </div>
                            <span v-if="globalLang == ''">Поделиться</span>
                            <span v-if="globalLang == 'kz/'">Бөлісу</span>
                            <svgIcon name="share" class="icon-share"/>
                        </div>
                    </div>
                    <div class="card-img" :style="'background-image: url(' + cardArr.img_big + ')'"></div>
                    <button class="video-view-link" v-if="cardArr.video_init && cardArr.video_link != ''" @click="openVideoModal">
                        <span>Смотреть видео</span>
                        <svgIcon name="video" class="icon-video"/>
                    </button>
                </div>
                <div class="col-right">
                    <div class="card-desc" v-html="cardArr.desc"></div>
                </div>
            </div>
        </div>
        <div class="container container-other-items">
            <div class="other-news-container" v-if="otherNewsArr != null && otherNewsArr.length > 0">
                <div class="section-title"><h2><span v-if="globalLang == ''">Другие новости</span><span v-else>Басқа жаңалықтар</span></h2></div>
                <newsItems :newsItems="otherNewsArr" class="news-other-items"></newsItems>
            </div>
        </div>
        <formPage></formPage>
        <modal name="video-modal" 
            @before-close="beforeVideoModalClose" 
            @closed="videoModalClosed" 
            :transition="transitionName" 
            :width="modalWidth" 
            :height="modalHeight" 
            :scrollable="modalScrollable"  
            class="video-item-modal"               
            id="video-modal">
            <div class="modal-content">
                <div class="video-player" v-if="cardArr.video_link != ''">
                    <iframe :src="cardArr.video_link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                </div>
                <a href="#" class="close-link" @click.prevent="closeVideoModal">
                    <svgIcon name="close" class="icon-close"/>
                </a>
            </div>
        </modal>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import newsItems from '@/components/news-page/news-item.vue'
    import formPage from '@/components/forms/form-page.vue'
    import { STelegram, SWhatsApp } from 'vue-socials'
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    export default {
        name: 'news-card',
        components: {
            newsItems,
            formPage,
            svgIcon,
            SWhatsApp,
            STelegram,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                cardID: this.$route.params.id,
                otherNewsArr: null,
                cardArrDate: null,
                cardArr: null,
                newsId: 0,
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    date: null,
                    title: null,
                    link: null
                },
                transitionName: 'pop-out',
            }
        },
        methods: {
            parseTitle(title) {
                var temporalDivElement = document.createElement("div");
                temporalDivElement.innerHTML = title;
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8, 10));
                var month = date.slice(5, 7);
                var year = date.slice(0, 4);
                var monthFont;
                var total;
                var monthNames = {
                    '01': { 'kz/': 'Қаңтар', 'en/': 'January', 'default': 'Января' },
                    '02': { 'kz/': 'Ақпан', 'en/': 'February', 'default': 'Февраля' },
                    '03': { 'kz/': 'Наурыз', 'en/': 'March', 'default': 'Марта' },
                    '04': { 'kz/': 'Сәуiр', 'en/': 'April', 'default': 'Апреля' },
                    '05': { 'kz/': 'Мамыр', 'en/': 'May', 'default': 'Мая' },
                    '06': { 'kz/': 'Маусым', 'en/': 'June', 'default': 'Июня' },
                    '07': { 'kz/': 'Шiлде', 'en/': 'July', 'default': 'Июля' },
                    '08': { 'kz/': 'Тамыз', 'en/': 'August', 'default': 'Августа' },
                    '09': { 'kz/': 'Қыркүйек', 'en/': 'September', 'default': 'Сентября' },
                    '10': { 'kz/': 'Қазан', 'en/': 'October', 'default': 'Октября' },
                    '11': { 'kz/': 'Қараша', 'en/': 'November', 'default': 'Ноября' },
                    '12': { 'kz/': 'Желтоқсан', 'en/': 'December', 'default': 'Декабря' }
                };
                monthFont = monthNames[month] ? monthNames[month][this.globalLang] || monthNames[month]['default'] : '';
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
            openVideoModal(date, title, link) {
                this.$modal.show('video-modal');
                document.getElementsByTagName('body')[0].classList.add('video_open');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            getOtherNews() {
                // console.log(this.newsId, 'NEWS CARD ARR');
                axios.get(window.url + window.GlobalLang + 'wp-json/vweb/v1/newsother?exclude_id='+ this.newsId +'&per_page=3').then(async (response) => {
                    this.otherNewsArr = response.data.posts;
                    // console.log(response, 'OTHER news ITEMs');
                });
            },
        },
        computed: mapGetters({
            // pageSetup: 'loadNewsPage',
            // newsItems: 'loadNewsItems',
        }),
        beforeRouteEnter (to, from, next) {
            // console.log(to);
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?slug=' + to.params.id).then(async (response) => {
                console.log(response, 'NEWS CARD');
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArrDate = response.data[0].date;
                        vm.cardArr = response.data[0].acf;
                        vm.newsId = response.data[0].id;
                        vm.getOtherNews();
                    });
                } else {
                    next('/404');
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
        },
        created () {
            document.body.dataset.page = 'news-card';

        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-card.scss';
    @import '@/styles/components/news-page/respond/news-card-respond.scss';
</style>